import { PrimaryButtonWithIcon } from '../../../../common/components/buttons/NewButtons.styles';
import { AddIcon, RearrangeIcon, DownloadIcon, ListIcon, ThreeDotsIcon, ArrowIcon } from '../../assets/icons';
import { EntitiesHeaderWrapper, HeaderControls, HeaderTitle, IconButton, DropdownMenu, DropdownMenuItem } from './EntitiesHeader.styles';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { useStore } from '../../../app/data/root.store';
import { Dropdown } from 'antd';
import { observer } from 'mobx-react';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
import { createEntityManagementCTAClickEvent } from '../../data/entities.mixpanel-events';

export const EntitiesHeader = observer(({ nodes, handleAddEntity, handleRearrangeClick }) => {
    const { uiStore, entitiesStore } = useStore();
    const { mixpanelTrack } = useAnalytics();

    const isMobile = !uiStore.isEntitiesPageThreshold;

    const handleDownloadClick = () => {
        if (nodes.length > 0) {
            mixpanelTrack('CTA Clicked', createEntityManagementCTAClickEvent('Export structure', 'Entity Management Bar'));
            entitiesStore.handleDownload();
        }
    };

    const handleAddEntityClick = () => {
        mixpanelTrack('CTA Clicked', createEntityManagementCTAClickEvent('Add entity', 'Entity Management Bar'));
        handleAddEntity();
    };

    const actionButtons = (
        <>
            <ModifiedTooltip title="Rearrange structure">
                <IconButton onClick={handleRearrangeClick}>
                    <RearrangeIcon style={{flexShrink: 0}} />
                </IconButton>
            </ModifiedTooltip>
            <ModifiedTooltip title="Export structure">
                <IconButton onClick={handleDownloadClick} disabled={nodes.length === 0}>
                    <DownloadIcon style={{flexShrink: 0}} />
                </IconButton>
            </ModifiedTooltip>
        </>
    );

    const dropdownMenu = (
        <DropdownMenu>
            {!uiStore.isDesktopView && <DropdownMenuItem onClick={entitiesStore.handleShowEntityList}>
                <ListIcon style={{ flexShrink: 0 }} /> List view <ArrowIcon style={{ marginLeft: 'auto', width: 16, height: 16 }} />
            </DropdownMenuItem>}
            <DropdownMenuItem onClick={handleRearrangeClick}>
                <RearrangeIcon />
                Rearrange structure
            </DropdownMenuItem>
            <DropdownMenuItem 
                onClick={handleDownloadClick}
                disabled={nodes.length === 0}
            >
                <DownloadIcon />
                Export structure
            </DropdownMenuItem>
        </DropdownMenu>
    );

    return (
        <EntitiesHeaderWrapper isThreshold={uiStore.isEntitiesPageThreshold}>
            <HeaderTitle>Entities Management</HeaderTitle>
            <HeaderControls>
                {!isMobile ?
                    actionButtons
                    :
                    <ModifiedTooltip title="View entity list">
                        <IconButton onClick={entitiesStore.handleShowEntityList} style={{ width: 'auto' }}>
                            <ListIcon style={{ flexShrink: 0 }} /> List view
                        </IconButton>
                    </ModifiedTooltip>
                }
                <PrimaryButtonWithIcon
                    onClick={handleAddEntityClick}
                    isIconAfterText={true}
                >
                    <AddIcon />
                    Add entity
                </PrimaryButtonWithIcon>
                {isMobile && 
                    <Dropdown 
                        overlay={dropdownMenu}
                        trigger={['click']}
                        placement="bottomRight"
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    >
                        <ThreeDotsIcon style={{ flexShrink: 0, cursor: 'pointer' }} />
                    </Dropdown>
                }
            </HeaderControls>
        </EntitiesHeaderWrapper>
    );
});